import { render, staticRenderFns } from "./SolutionsCarouselSlider.vue?vue&type=template&id=b2038da2"
import script from "./SolutionsCarouselSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./SolutionsCarouselSlider.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiIcon.vue').default,SolutionsCarouselSlide: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/sections/sliderSection/SolutionsCarouselSlide.vue').default})
